import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';

export type ResendVerificationEmailInput = {
  userId: string;
};

export const requestNewVerifyEmail = () =>
  restClient.request('/api/v1/auth/send_verification_email', { method: 'POST' });

export const adminResendVerificationEmail = async (data: ResendVerificationEmailInput) => {
  restClient.request('/api/v1/admin/resend_verification_email', {
    method: 'POST',
    data: snakecaseKeys(data)
  });
};
